// components/ModalConfig.jsx
import React from "react";
import Modal from "react-modal";

const modalNoCotizacion = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "500px",
    padding: "20px",
    borderRadius: "5px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    border: "none",
    fontFamily: "Roboto, sans-serif",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 102,
  },
  h2: {
    fontSize: "20px",
    color: "#333",
    marginBottom: "15px",
    textAlign: "left",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  radioGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  radioLabel: {
    fontSize: "1rem",
    color: "#666",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  inputGroup: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginLeft: "45px",
    marginTop: "10px",
    marginBottom: "10px",
  },
  inlineLabel: {
    fontSize: "0.9rem",
    color: "#666",
  },
  smallInput: {
    width: "100px",
    padding: "5px",
    fontSize: "0.9rem",
    borderRadius: "5px",
    border: "1px solid #ddd",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    gap: "10px",
  },
  button: {
    padding: "8px 15px",
    fontSize: "0.9rem",
    borderRadius: "5px",
    border: "none",
    color: "#fff",
    backgroundColor: "#007bff",
    cursor: "pointer",
  },
  buttonCancel: {
    backgroundColor: "#6c757d",
  },
};

const ModalConfig = ({
  modalConfigIsOpen,
  setModalConfigIsOpen,
  modoNumero,
  handleModoCambio,
  guardarConfiguracionNumero,
  prefijo,
  setPrefijo,
  siguienteNumero,
  setSiguienteNumero,
}) => {
  return (
    <Modal
      isOpen={modalConfigIsOpen}
      onRequestClose={() => setModalConfigIsOpen(false)}
      style={modalNoCotizacion}
    >
      <h2 style={modalNoCotizacion.h2}>Configurar preferencias de número</h2>
      <form onSubmit={guardarConfiguracionNumero} style={modalNoCotizacion.form}>
        <div style={modalNoCotizacion.radioGroup}>
          <label style={modalNoCotizacion.radioLabel}>
            <input
              type="radio"
              name="modoNumero"
              value="auto"
              checked={modoNumero === "auto"}
              onChange={handleModoCambio}
              style={{ marginRight: "5px" }}
            />
            Continuar generando automáticamente números
          </label>
          {modoNumero === "auto" && (
            <div style={modalNoCotizacion.inputGroup}>
              <label htmlFor="prefijo" style={modalNoCotizacion.inlineLabel}>
                Prefijo
              </label>
              <input
                type="text"
                id="prefijo"
                value={prefijo}
                onChange={(e) => setPrefijo(e.target.value)}
                style={modalNoCotizacion.smallInput}
              />
              <label htmlFor="siguienteNumero" style={modalNoCotizacion.inlineLabel}>
                Siguiente número
              </label>
              <input
                type="number"
                id="siguienteNumero"
                value={siguienteNumero !== "" ? String(siguienteNumero).padStart(4, "0") : ""}
                onChange={(e) => {
                  const rawValue = e.target.value;
                  if (/^0+$/.test(rawValue)) {
                    setSiguienteNumero(rawValue);
                  } else {
                    const trimmed = rawValue.replace(/^0+(?!$)/, "");
                    setSiguienteNumero(trimmed);
                  }
                }}
                style={modalNoCotizacion.smallInput}
              />
            </div>
          )}
        </div>
        <label style={modalNoCotizacion.radioLabel}>
          <input
            type="radio"
            name="modoNumero"
            value="manual"
            checked={modoNumero === "manual"}
            onChange={handleModoCambio}
            style={{ marginRight: "5px" }}
          />
          Introduzca manualmente el número
        </label>
        <div style={modalNoCotizacion.buttonContainer}>
          <button
            type="button"
            onClick={() => setModalConfigIsOpen(false)}
            style={{ ...modalNoCotizacion.button, ...modalNoCotizacion.buttonCancel }}
          >
            Cancelar
          </button>
          <button type="submit" style={modalNoCotizacion.button}>
            Guardar
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ModalConfig;
